import { CHANGE_EQUIPMENT_FILTER } from "constants/constants";
import { genKey, getStorage, setStorage } from "components/utils/Storage";
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';

const getInitialFilter = () => {
  const filters = getStorage(genKey("filters"));
  if (filters) {
    if (isMobile) {
      filters.alarmType = 0;
    }
    return filters;
  } else {
    const initialFilter = {
      familyEquipment: [],
      autorouteEquipment: [],
      search: '',
      alarmType: 1
    };
    if (isMobile) {
      initialFilter.alarmType = 0;
    }
    setStorage(genKey("filters"), initialFilter);
    return initialFilter;
  }
}

const initialState = getInitialFilter();

const FilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_EQUIPMENT_FILTER:
      setStorage(genKey("filters"), action.value);
      return action.value;
    default:
      return state;
  }
};

export default FilterReducer;
